import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import { ui } from '@/constants';
import { ScanlessIntroductionContentFragment } from '@/models/cms';
import { AccountPageLoadEvent } from '@/services/analytics/events';

@Component({
  name: 'CmgScanlessIntroModal',
})
export default class CmgScanlessIntroModal extends Vue {
  private scanlessContentState: ScanlessIntroductionContentFragment = { isModalEnabled: false };

  get visible(): boolean {
    return this.$appStore.state.ui.modals.scanlessIntroModal.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get scanlessContent(): ScanlessIntroductionContentFragment {
    return this.scanlessContentState;
  }

  get modalImageSrc(): string {
    return this.scanlessContent.imageUrl || this.$appStore.state.cms.images.logos.autoAccrualAnimated.default;
  }

  get modalTitle(): string {
    return this.scanlessContent.heading || 'SCANLESS';
  }

  get modalDisplayTitle(): string {
    if (/AUTO\s+ACCRUAL/i.test(this.modalTitle)) {
      return this.modalTitle.replace(/\s+ACCRUAL\b/i, '\nACCRUAL');
    }

    return this.modalTitle;
  }

  get modalBodyHtml(): string {
    return this.scanlessContent.bodyHtml || '';
  }

  get modalFooterHtml(): string {
    return this.scanlessContent.footerHtml || '';
  }

  @Watch('visible', { immediate: true })
  async onVisibleChanged(isVisible: boolean): Promise<void> {
    this.scanlessContentState = this.$services.config.getScanlessIntroductionModal();

    if (isVisible && !this.scanlessContentState.isModalEnabled) {
      await this.$services.config.setScanlessIntroductionModal();
      this.scanlessContentState = this.$services.config.getScanlessIntroductionModal();
    }
  }

  close(): void {
    this.$services.analytics.send(new AccountPageLoadEvent('payments'));
    this.$services.ui.setModalVisibility('scanlessIntroModal', false);
  }
}
